// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"style_checkboxContainer__aptz1","checked":"style_checked__MrWUi","checkbox":"style_checkbox__7gQu4","checkIcon":"style_checkIcon__ouevK"};